<template>
    <v-content :style="mini  ? 'padding: 0px 0px 0px 80px;' : 'padding: 64px 0px 0px 256px;'" >
        <v-container class="mt-n8" fluid style="position: relative">
            <v-col cols="12">
                <v-card raised>
                  <!-- Full screen package vue-fullscreen applied  -->
                  <fullscreen v-model="fullscreen">
                    <div class="iframe-container" :style="{ 'padding-top': fullscreen ? '60%' : '47.00%', 'overflow': 'hidden', 'position': 'relative' }">
                      <iframe id="iframemodule" :src="completeurl" style="border: 0;height: 100%;left: 0; position: absolute; top: 0; width: 100%;" allowfullscreen></iframe>
                    </div>
                  </fullscreen>

               
                  
                </v-card>   
                <v-btn icon @click="toggle" class="float-end mt-n8">
                    <v-icon x-large class="module-fullscreen" v-if="!fullscreen"> mdi-fullscreen</v-icon>
                    <v-icon x-large class="module-fullscreen" v-else> mdi-fullscreen-exit</v-icon>
                  </v-btn>             
            </v-col>
        </v-container>
        <Dialogbox
          @redirect="redirect"
          :title="dialogboxtitle"
          :dialog="dialogstatus"
          :buttonTitle="dialogButtontitle"
          :closestatus='false'
          :redirect="true"
          v-if="dialogstatus"
        />

        <v-dialog v-model="feedbackDialog" persistent max-width="560">
          <v-card>
            <v-card-title class="headline">{{ feedbackMessage| translate }}</v-card-title>
            <v-card-text>
            <span v-if="feedbackMessage=='You already passed test!'">
              <v-btn small class="ml-6 white--text" :color="primary_color" :to="'/test-center'" >{{ 'Jump to Course'| translate }}</v-btn>
            </span>
          </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" text @click="feedbackDialog = false">{{ 'Close'| translate }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

    </v-content>
    
</template>

<script>
import { CourseFeedbackService } from "@/common/api.service";
import { mapGetters } from "vuex";
import store from "@/store";
import VueFullscreen from 'vue-fullscreen';
import Vue from 'vue';
Vue.use(VueFullscreen);
import { FETCH_INDIVIDUAL_MODULE, SAVE_USER_SLIDE_ID, SAVE_USER_MODULE_PROGRESS, RESET_STATE } from "@/store/actions.type";
import { SET_LOADING, SET_SNACKBAR ,SET_ROUTER_ENTER } from "@/store/mutations.type"
export default {
  name: "ModulesDetails", 
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch(RESET_STATE);
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(RESET_STATE);
    await store.dispatch(FETCH_INDIVIDUAL_MODULE,to.params.id+'?course_id='+to.params.courseId);
    store.commit(SET_ROUTER_ENTER, false)

    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(RESET_STATE);
    next();
  }, 
  components: {
    Dialogbox: () => import("@/components/dialog/dialog")
  },   
  computed: {
    ...mapGetters(["currentUser","individualmodule", "widthValue", 'mini', 'curLanguage']),
  },
  mounted () {
      if(!this.individualmodule.module_id){
        this.feedbackDialog=true
        this.feedbackMessage = "Invalid route"
      }
      else{
        if(this.individualmodule.is_subscribed === false){
          this.$router.push("/modules/"+this.individualmodule.module_id);
        } 
        else if(this.individualmodule.show_player === false) {
              this.dialogstatus=true
              this.dialogboxtitle = 'Please subscribe to course'
              this.dialogButtontitle  = 'Go to courses'
              this.$store.commit(SET_LOADING, false)  
        }
        if (window['postMessage']){
          if (window.addEventListener) {
            window.addEventListener('message', this.ReceiveMessage, false);
          }
          else {
            window.attachEvent('onmessage', this.ReceiveMessage);
          }
        }    
        let company_meta  = JSON.parse(this.currentUser.company.company_meta)
        this.primary_color  = company_meta.primary_color  
        this.token = encodeURIComponent('Basic '+this.currentUser.learn_lock_auth)
        this.path = this.individualmodule.module_versions.full_path
        this.endpoint = encodeURIComponent(process.env.VUE_APP_LEARNING_LOCKER)
        this.actor = encodeURIComponent('{"mbox":"mailto:'+this.currentUser.hash_email+'","name":"'+this.currentUser.name+'","objectType":"Agent"}')
        this.completeurl = process.env.VUE_APP_PLAYER_URL+this.path+'?endpoint='+this.endpoint+'&auth='+this.token+'&actor='+this.actor+'&courseId='+localStorage.getItem("lastCourseVisitedId")+'&moduleId='+this.individualmodule.module_id+'&subscriptionId='+this.individualmodule.subscription_id
      }
 },
 methods :{
      toggle () {
        this.fullscreen = !this.fullscreen
      },
      saveReport () {
        if (this.$refs.bugForm.validate()) {
          CourseFeedbackService.post('',{
              slide_id: this.slideid,
              message: this.reportmessage,
              module_id: this.individualmodule.module_id
            })
            .then(resp => {
              if (resp.data != undefined && resp.data.hasOwnProperty('success') && resp.data.success) {
                this.message = "Bug sent successfully";
                this.$store.commit(SET_SNACKBAR, {status: true, message: this.message })
                this.$store.commit(SET_LOADING, false);
                this.closeReportDialog();
              }
            })
            .catch(error => {
                this.errors = error.response.data.errors;
                this.$store.commit(SET_LOADING, false);
            })
        }
      },
      openReportDialog () {
        this.reportDialogStatus = true;
      },
      redirect(){
        this.$router.push('/courses')
      },
      closeReportDialog () {
        this.message = '';
        this.errors = {};
        this.reportDialogStatus = false;
      },
			ReceiveMessage(evt) {
        //Articulate files
        if (evt.origin === process.env.VUE_APP_PLAYER_URL && this.courseprogressid != (JSON.parse(evt.data).courseProgress))
				{
          this.courseprogressid  = JSON.parse(evt.data).courseProgress
          this.$store.dispatch(SAVE_USER_MODULE_PROGRESS,{
            course_id: localStorage.getItem("lastCourseVisitedId"),
            courseProgress: this.courseprogressid,
            module_id: this.individualmodule.module_id}).then(resp =>{
            if(resp.success == true){
              store.commit(SET_LOADING, false)
            }
          })
				}

        //Captivate files
				if (evt.origin === process.env.VUE_APP_PLAYER_URL&& this.slideid != (JSON.parse(evt.data).slideid))
				{
          this.slideid  = JSON.parse(evt.data).slideid
          this.$store.dispatch(SAVE_USER_SLIDE_ID,{
            course_id: localStorage.getItem("lastCourseVisitedId"),
            slide_id: this.slideid,
            module_id: this.individualmodule.module_id}).then(resp =>{
            if(resp.success == true){
              store.commit(SET_LOADING, false)
            }
          })
				}
      }
 },
  data() {
    return {
        token: null,
        path: null,
        endpoint: null,
        completeurl: null,
        actor:null,
        slideid: null, //for captivate files
        courseprogressid: null, //for articulate files
        dialogstatus: false,
        dialogButtontitle: null,
        dialogboxtitle: null,
        primary_color: '',
        reportDialogStatus: false,
        reportmessage: '',
        message: '',
        errors: {},
        feedbackDialog: null,
        feedbackMessage: null,
        fullscreen: false,
    };
  },   
}
</script>